export const FONT_WEIGHT_REGULAR = 400;
export const FONT_WEIGHT_SEMIBOLD = 600;
export const FONT_WEIGHT_BOLD = 700;
